
import { Comment } from "../../classes"

const CoomentModule = {
  namespaced: true,
  state: {
    comments: null,
  },
  mutations: {
    setComments(state, comments) {
      state.comments = comments || []
    },
    clearComments(state){
      state.comments = null
    },
  },
  actions: {
    createComment: async ({ commit }, formData) => {
      try{
        const data = await Comment.createComment(formData)
        return data
      }catch(error){
        throw error
      }
    },
    getCommentByPost: async ({ commit }, { postId }) => {
      try{
        commit("clearComments")
        const data = await Comment.getCommentByPost({ postId })
        commit("setComments", data)
        return data
      }catch(error){
        throw error
      }
    },
  },
  getters: {

  },
};
export default CoomentModule;
